import React from 'react';
export const Hero = () => {
  return <section className="relative w-full h-screen bg-gray-900 text-white overflow-hidden" data-id="element-237">
      {/* Video Background */}
      <div className="absolute inset-0 w-full h-full" data-id="element-238">
        <video className="absolute inset-0 min-w-full min-h-full object-cover opacity-50" autoPlay loop muted playsInline data-id="element-239">
          <source src="https://www.koda-is.com/custom/banner-vid.mp4" type="video/mp4" data-id="element-240" />
          {/* Fallback for browsers that don't support video */}
          Your browser does not support the video tag.
        </video>
        {/* Overlay to ensure text readability */}
        <div className="absolute inset-0 bg-black opacity-40" data-id="element-241"></div>
      </div>
      {/* Content */}
      <div className="relative container mx-auto px-4 h-full flex items-center justify-center" data-id="element-242">
        <div className="max-w-2xl pt-32 md:pt-0 text-center" data-id="element-243">
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold mb-4 drop-shadow-lg" data-id="element-244">
            Professional Security & Investigation Services
          </h1>
          <p className="text-lg md:text-xl mb-8 drop-shadow" data-id="element-245">
            We cover the State of Michigan and beyond for your investigative and
            security needs. Licensed in Michigan, Illinois, Indiana, and Ohio.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-246">
            <a href="#services" className="bg-kgi-red hover:bg-kgi-red-600 text-white font-bold py-3 px-6 rounded transition duration-300 text-center" data-id="element-247">
              Our Services
            </a>
            <a href="#contact" className="bg-white hover:bg-gray-100 text-kgi-blue-700 font-bold py-3 px-6 rounded transition duration-300 text-center" data-id="element-248">
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>;
};